import { render, staticRenderFns } from "./ReferralActionWithInputBox.vue?vue&type=template&id=0a2c472f"
import script from "./ReferralActionWithInputBox.vue?vue&type=script&lang=js"
export * from "./ReferralActionWithInputBox.vue?vue&type=script&lang=js"
import style0 from "./ReferralActionWithInputBox.vue?vue&type=style&index=0&id=0a2c472f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports